import Vue from 'vue'

export function register (elements, store, apolloProvider) {
  Object.keys(elements).forEach(tag => {
    const component = elements[tag]
    component.store = store
    component.apolloProvider = apolloProvider
    Vue.config.ignoredElements.push(tag)
    Vue.customElement(tag, component)
  })
}
